"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfFormattingInfo = void 0;
var unicode_character_decoder_1 = require("../../encoding/unicode-character-decoder");
var code_page_character_decoder_1 = require("../../encoding/code-page-character-decoder");
var code_pages_1 = require("../../encoding/code-pages");
var rtf_import_data_1 = require("../../rtf-import-data");
var RtfFormattingInfo = (function () {
    function RtfFormattingInfo() {
        this._unicodeCharacterByteCount = 1;
        this._codePage = code_pages_1.CodePages.default;
        this.codePageDecoder = new code_page_character_decoder_1.CodePageCharacterDecoder(this.codePage);
        this.unicodeDecoder = new unicode_character_decoder_1.UnicodeCharacterDecoder();
        this.activeDecoder = this.codePageDecoder;
    }
    Object.defineProperty(RtfFormattingInfo.prototype, "unicodeCharacterByteCount", {
        get: function () { return this._unicodeCharacterByteCount; },
        set: function (value) {
            if (value < 0)
                rtf_import_data_1.RtfImportData.throwInvalidRtfFile();
            this._unicodeCharacterByteCount = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RtfFormattingInfo.prototype, "codePage", {
        get: function () { return this._codePage; },
        set: function (value) {
            if (this._codePage == value)
                return;
            this._codePage = value;
            this.onCodePageChanged();
        },
        enumerable: false,
        configurable: true
    });
    RtfFormattingInfo.prototype.onCodePageChanged = function () {
        this.codePageDecoder.codePage = this.codePage;
    };
    RtfFormattingInfo.prototype.clone = function () {
        var clone = this.createEmptyClone();
        clone.copyFrom(this);
        return clone;
    };
    RtfFormattingInfo.prototype.createEmptyClone = function () {
        return new RtfFormattingInfo();
    };
    RtfFormattingInfo.prototype.copyFrom = function (info) {
        this.unicodeCharacterByteCount = info.unicodeCharacterByteCount;
        this.codePage = info.codePage;
        this.deleted = info.deleted;
    };
    return RtfFormattingInfo;
}());
exports.RtfFormattingInfo = RtfFormattingInfo;
